<script setup lang="ts">
import { ref, type PropType } from 'vue';
import {useFormStore} from '@/stores/forms';
import MultiSelect, { type MultiSelectChangeEvent } from 'primevue/multiselect';

const props = defineProps({
  selectedFormsIds: {
    type: Array as PropType<string[]>,
    required: true
  }
});

const formStore = useFormStore();

const selectedForms = ref(formStore.formList.filter(form => props.selectedFormsIds.includes(form.base64Id as string)));

const emit = defineEmits(['onFormChangeListener']);

const onChangeListener = (data: MultiSelectChangeEvent) => {
  emit('onFormChangeListener', data.value);
};
</script>

<template>
    <MultiSelect v-model="selectedForms"
        :options="formStore.formList"
        optionLabel="title"
        placeholder="Select Forms"
        @change="onChangeListener">
        <template #value="slotProps">
            {{ slotProps.value.length == formStore.formList.length ? "All forms" : `${slotProps.value.length} forms`  }}
        </template>
    </MultiSelect>
</template>

<style scoped lang="scss">
.p-multiselect {
    width: 250px;
}
</style>
